import { Avatar, Box, Typography } from "@mui/material";
import { Tab } from "react-admin";
import { grants } from "../backoffice.access_control";
import { overviewCardStyle } from "../misc/backofficeTheme";
import { ShowBase } from "../misc/ShowBase";
import { Tabs } from "../misc/Tabs";
import { Row } from "../misc/Row";
import { LoadingIndicator } from "../misc/LoadingIndicator";
import { NameHeader } from "../misc/NameHeader";
import { Employee } from "../providers/employeesProvider";
import { EmployeeAdminForm } from "./employee/EmployeeAdminForm";
import { EmployeeData } from "./employee/EmployeeData";
import { useRecordAndSwitchDrivingSchoolIfNecessary } from "../hooks/useRecordAndSwitchDrivingSchoolIfNecessary";
import { Column } from "../misc/Column";
import { BackButton } from "../buttons/BackButton";

export function EmployeeDetails() {
  const employee = useRecordAndSwitchDrivingSchoolIfNecessary<Employee>((it) => it.drivingSchoolId);

  if (!employee) {
    return <LoadingIndicator />;
  }

  return (
    <ShowBase>
      <_EmployeeDetailsTabs employee={employee} />
    </ShowBase>
  );
}

function _EmployeeDetailsHeader({ employee }: { employee: Employee }) {
  return (
    <Column>
      <Row sx={{ my: "15px" }}>
        <BackButton
          url={`/drivingSchools/${employee.drivingSchoolId}/employees#${employee.disabled ? "office-inactive" : "office"}`}
        >
          {employee.disabled ? "Büro (inaktiv)" : "Büro"}
        </BackButton>
      </Row>
      <Row sx={{ mb: "20px" }} spacing="50px" alignItems="start">
        <Row spacing="20px" alignItems="center">
          <Avatar src={employee.avatarUrl} sx={{ width: "60px", height: "60px" }} />
          <Box sx={{ ml: "20px", display: "flex", flexDirection: "column" }}>
            <NameHeader>{employee.name}</NameHeader>
            <Typography sx={{ color: "text.secondary", fontSize: "14px", lineHeight: "1.43" }}>Support</Typography>
          </Box>
        </Row>
        <Row sx={{ flexWrap: "wrap" }} alignItems="center">
          {/*  <HeaderField ... */}
        </Row>
      </Row>
    </Column>
  );
}

function _EmployeeDetailsTabs(props: { employee: Employee }) {
  return (
    <Tabs
      sx={{ ...overviewCardStyle, padding: "5px 30px 10px 30px" }}
      header={<_EmployeeDetailsHeader {...props} />}
      separateCards
    >
      <Tab label="Stammdaten" /* no path attribute here, so the tab is shown by default */>
        <EmployeeData />
      </Tab>
      {grants.has("manageUsers") && (
        <Tab label="Einstellungen" path="admin">
          <EmployeeAdminForm />
        </Tab>
      )}
    </Tabs>
  );
}
